module.exports = __webpack_public_path__ + "img/80.8e4b34c8.svg";